import React from "react"
import styled from "@emotion/styled"
import FacebookIconImage from "./images/share-icon-facebook-image"
import TwitterIconImage from "./images/share-icon-twitter-image"
import InstagramIconImage from "./images/share-icon-instagram-image"
import LineIconImage from "./images/share-icon-line-image"
import WwdLogoImage from "./wwd-logo-image"

const Container = styled.div`
  padding: 16px;
  text-align: center;
`
const Share = styled.ul`
  font-size: 1.125rem;
  color: #ffffff;
  padding: 2rem 0 2rem;
  display: table;
  margin: 0 auto;

  .sponly {
    display: none !important;
    @media (max-width: 576px) {
      display: table-cell !important;
    }
  }
`
const ShareContent = styled.li`
  font-size: 1.125rem;
  color: #ffffff;
  padding: 0 1rem;
  display: table-cell;
`
const ShareLink = styled.a`
  img {
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;
  }
  :hover img {
    opacity: 0.35 !important;
  }
`

const WWDLogo = styled.div`
  z-index: 100;
  width: 100%;
  font-weight: bold;
  text-align: center;

  svg {
    margin-bottom: 1rem;
    width: 100px;
    fill: #ffffff;
  }
`
const Copyright = styled.p`
  // 8px
  font-size: 0.5rem;
  color: #ffffff;
  line-height: 1.6;
  margin: 0 auto 6rem;
  @media (max-width: 576px) {
    width: 85%;
  }
`
const Footer = () => (
  <footer>
    <Container>
      <Share>
        <ShareContent>
          <ShareLink href="https://www.facebook.com/WWDJapan" target="_blank">
            <FacebookIconImage>Facebook</FacebookIconImage>
          </ShareLink>
        </ShareContent>
        <ShareContent>
          <ShareLink href="https://twitter.com/wwd_jp" target="_blank">
            <TwitterIconImage>Twitter</TwitterIconImage>
          </ShareLink>
        </ShareContent>
        <ShareContent>
          <ShareLink href="https://www.instagram.com/wwd_jp/" target="_blank">
            <InstagramIconImage>Instagram</InstagramIconImage>
          </ShareLink>
        </ShareContent>
        <ShareContent className="sponly">
          <ShareLink href="https://line.me/R/ti/p/@oa-wwdjapan" target="_blank">
            <LineIconImage>Line</LineIconImage>
          </ShareLink>
        </ShareContent>
      </Share>
      <WWDLogo>
        <WwdLogoImage></WwdLogoImage>
      </WWDLogo>
      <Copyright>
        Copyright&copy; 2013 INFAS PUBLICATIONS WWD JAPAN All rights reserved.
        <br />
        Contains material reprinted by permission from WWD&copy; 2018 FAIRCHILD
        PUBLISHING, LLC. All rights reserved.
      </Copyright>
    </Container>
  </footer>
)

export default Footer
